import {
  APPLY_OFFER_FAIL,
  APPLY_OFFER_RESET,
  APPLY_OFFER_START,
  APPLY_OFFER_SUCCESS,
} from "./constants";
import {ApplyOfferActions, ApplyOfferState} from "./types";

const initialState: ApplyOfferState = {
  loading: false,
  data: undefined,
  error: undefined,
}

const reducer = (
  state = initialState,
  action: ApplyOfferActions,
): ApplyOfferState => {
  switch (action.type) {
    case APPLY_OFFER_START:
      return {
        ...initialState,
        loading: true,
      }
    case APPLY_OFFER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      }
    case APPLY_OFFER_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      }
    case APPLY_OFFER_RESET:
      return {
        ...initialState,
      }
    default:
      return state;
  }
}

export default reducer;
